var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12ZM17.4281 9.92813C17.9391 9.41719 17.9391 8.58281 17.4281 8.07187C16.9172 7.56094 16.0828 7.56094 15.5719 8.07187L10.5 13.1437L8.42813 11.0719C7.91719 10.5609 7.08281 10.5609 6.57187 11.0719C6.06094 11.5828 6.06094 12.4172 6.57187 12.9281L9.57187 15.9281C10.0828 16.4391 10.9172 16.4391 11.4281 15.9281L17.4281 9.92813Z",
    fill: "#014971"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckSolid);
export default __webpack_public_path__ + "static/media/circle-check-solid.637f21cd2e3417b2e283e6776eb99c38.svg";
export { ForwardRef as ReactComponent };